<template>
  <span>
    <h4>Список документов:</h4>
    <el-table
      v-loading="loading"
      :data="table"
      element-loading-text="Загрузка..."
      stripe
      style="width: 100%"
      max-height="500px"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      @expand-change="expandSelect"
    >
      <el-table-column type="expand" width="15%">
        <template slot-scope="props">
          <new-list-uploaded-files
            v-if="props.row.files.length > 0"
            :file-list="props.row.files"
            :is-signed="Boolean(props.row.is_signed)"
            type-document="contract"
            @getZip="getsZip(props.row.id)"
            @deleteOne="deleteOneFile"
          />
          <new-upload-files
            :docunent-id="props.row.id"
            :pasted-file="pastedFile"
            @uploaded="upload"
            @onStartedUpload="onStartedUpload"
            @aborted="onAbort"
            @uploadImages="uploadImages"
          />
        </template>
      </el-table-column>
      <el-table-column label="№ документа">
        <template slot-scope="scope">
          <span>
            <span style="margin-left: 10px">
              {{ scope.row.id ? scope.row.id : 'Нет номера' }}
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Файлы">
        <template slot-scope="scope">
          <span style="margin-left: 10px">
            {{ scope.row.count_doc ? scope.row.count_doc : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Дата СЗВМ" prop="dateCreate" sortable>
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>Дата: {{ getMontWithYear(scope.row.dateCreate) }}</p>
            <div slot="reference" class="name-wrapper" style="font-size: 14px">
              {{ getMontWithYear(scope.row.dateCreate) }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="Дата обновления" prop="dateUpdate" sortable>
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>Дата: {{ scope.row.dateUpdate }}</p>
            <div slot="reference" class="name-wrapper" style="font-size: 14px">
              {{ scope.row.dateUpdate }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="Действия" align="right">
        <template slot-scope="scope">
          <el-button
            class="table-btn-custom"
            size="mini"
            type="danger"
            plain
            icon="el-icon-delete"
            :loading="loading"
            :disabled="loading"
            @click="
              () =>
                $emit('deleteDocument', {
                  id: scope.row.id,
                })
            "
          />
        </template>
      </el-table-column>
    </el-table>
  </span>
</template>

<script>
import { fullDateWithTime } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'
import { kitcutText } from '@/helpers/functions'
import newListUploadedFiles from '@/components/Upload/newListUploadedFiles'
import newUploadFiles from '@/components/Upload/newUploadFiles'

export default {
  name: 'SzvmDocumentsList',
  components: {
    newUploadFiles,
    newListUploadedFiles,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    pastedFile: {
      type: File,
      default: undefined,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    contractId: {
      type: Number || String,
    },
  },
  data() {
    return {
      expands: [],
      getRowKeys(row) {
        return row.id
      },
      currentDocument: null,
      showInputEditTitle: null,
      numberInputEditTitle: null,
    }
  },
  computed: {
    table() {
      let arr = []

      arr = this.documents.map(document => ({
        dateCreate: getDateOfCertainFormat(
          document.document_create_date,
          fullDateWithTime,
        ),
        dateUpdate: getDateOfCertainFormat(
          document.updated_at,
          fullDateWithTime,
        ),
        id: document.id,
        files: document.files,
        count_doc: document.files.length,
      }))

      return arr.sort((a, b) => new Date(b.dateCreate) - new Date(a.dateCreate))
    },
  },
  methods: {
    getMontWithYear(date) {
      return date.slice(3, 10)
    },
    expandSelect(row, expandedRows) {
      let that = this

      if (expandedRows.length) {
        that.expands = []

        if (row) {
          that.expands.push(row.id)
        }
      } else {
        that.expands = []
      }
    },
    getsZip(id) {
      this.$emit('getZip', id)
    },
    deleteOneFile(data) {
      if (data.constructor === Array) {
        this.$confirm('Вы действительно хотите удалить все файлы?', 'Warning', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.$emit('deleteFile', data)
        })
      } else {
        this.$confirm(
          'Вы действительно хотите удалить файл ' + data + ' ?',
          'Warning',
          {
            confirmButtonText: 'Да',
            cancelButtonText: 'Нет',
            type: 'warning',
          },
        ).then(() => {
          this.$emit('deleteFile', [data])
        })
      }
    },
    onStartedUpload() {
      this.$emit('startUpload')
    },
    uploadImages(param1, param2) {
      this.$emit('uploadedImages', param1, param2)
    },
    upload(data) {
      this.$emit('uploaded', data)
    },
    onAbort() {
      this.$emit('onAborted')
    },

    shortText(text) {
      return kitcutText(text, 29)
    },
  },
}
</script>

<style lang="sass">
.table-btn-custom
  text-align: center!important
  margin: 3px 8px 8px 0px!important
.contract-list
  margin-top: 25px
  .list-row
    border-bottom: 1px dotted #ccc
    padding-top: 8px
    padding-bottom: 8px
  .activeDocument
    color: #67C23A
    font-weight: 500
    margin-right: 18px
    margin-left: 4px
  .signed
    color: #67C23A
    font-weight: 500
    margin-right: 18px
    margin-left: 4px
    &-icon
      font-size: 24px
  .red
    color: #F56C6C
  & .item
    min-height: 25px
    & .btn-contract-delete
      opacity: 0
      cursor: pointer
    &:hover .btn-contract-delete
      opacity: 1
    & .name
      color: #9C9C9C
      position: relative
      &.active
        color: #E6A23C
      & .approved
        position: absolute
        left: -11px
        top: 6px
        width: 4px
        height: 4px
        background-color: #67C23A
        border-radius: 5px
  & .title
    display: block
    color: #000000
    margin-bottom: 10px
</style>
